import { fromTheme } from 'src/styles/theme';
import styled from 'styled-components';
import { media } from 'src/styles/designs';
import { ConstraintContainer } from 'src/components/common/ConstraintContainer';

export const AboutUsSection = styled(ConstraintContainer).attrs({
  as: 'section',
})`
  color: ${fromTheme((theme) => theme.text.palette.primary)};
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 150%;

  ${media.w.greaterThanOrEqual.desktop} {
    font-size: 16px;
  }
`;
